'use client'

import { useEffect, useRef } from 'react'

export default function TabsKeyNavigationClient() {
  const tabsRef = useRef<HTMLElement[]>([])

  useEffect(() => {
    const tabs = Array.from(document.querySelectorAll('.c-mega-tabs__tab-btn')) as HTMLElement[]
    if (!tabs.length) return

    tabsRef.current = tabs

    const handleKeyDown = (e: KeyboardEvent) => {
      const currentIndex = tabsRef.current.findIndex(tab => tab === document.activeElement)
      if (currentIndex === -1) return

      let newIndex = currentIndex

      switch (e.key) {
        case 'ArrowRight':
          newIndex = (currentIndex + 1) % tabsRef.current.length
          e.preventDefault()
          break
        case 'ArrowLeft':
          newIndex = (currentIndex - 1 + tabsRef.current.length) % tabsRef.current.length
          e.preventDefault()
          break
        case 'Home':
          newIndex = 0
          e.preventDefault()
          break
        case 'End':
          newIndex = tabsRef.current.length - 1
          e.preventDefault()
          break
        default:
          return
      }
      tabsRef.current.forEach((tab, i) => {
        tab.tabIndex = i === newIndex ? 0 : -1
      })
      tabsRef.current[newIndex]?.focus()
    }
    tabsRef.current.forEach(tab => tab.addEventListener('keydown', handleKeyDown))

    return () => {
      tabsRef.current.forEach(tab => tab.removeEventListener('keydown', handleKeyDown))
    }
  }, [])

  return null
}
